import { BASE_VOWELS } from "@/app/(application)/(ttv)/ttv/components/ttvApplication/pianoRoll/utils/lyrics/constants";

const EMPTY_STRING = "";
// ARPABET stress digit: '0'..'2' (primary, secondary, unstressed)
const CHAR_CODE_STRESS_DIGIT_MIN = 48;
const CHAR_CODE_STRESS_DIGIT_MAX = 50;

export const isVowel = (p: string): boolean => {
  if (p === EMPTY_STRING) {
    return false;
  }
  const last = p.charCodeAt(p.length - 1);
  const hasStress =
    last >= CHAR_CODE_STRESS_DIGIT_MIN && last <= CHAR_CODE_STRESS_DIGIT_MAX;
  const core = hasStress ? p.slice(0, -1) : p;

  // BASE_VOWELS is uppercase ARPABET. Production callers go through wordToPhoneme (always uppercase), but clampFirstPhonemeStart and user- edited phonemes can pass mixed/lowercase — normalize so the lookup is case-insensitive instead of silently returning false.
  return BASE_VOWELS.has(core.toUpperCase());
};
